import clsx from 'clsx';
import React from 'react';

import styles from './timezoneToggle.module.scss';


type TimezoneToggleProps = {
  useLocalZone: boolean;
  setUseLocalZone: ( next: boolean ) => void;
  className?: string;
  groupLabel?: string;
  title?: string;
};

export function TimezoneToggle( {
  useLocalZone,
  setUseLocalZone,
  className,
  groupLabel = 'Timezone selection',
  title = 'Toggle between UTC and your local timezone'
}: TimezoneToggleProps ) {
  return (
    <div
      role="group"
      aria-label={ groupLabel }
      className={ clsx( styles.timezoneSegmented, className ) }
      title={ title }
    >
      <button
        type="button"
        aria-pressed={ !useLocalZone }
        onClick={ () => setUseLocalZone( false ) }
        className={ clsx( styles.timezoneOption, { [styles.active]: !useLocalZone } ) }
      >
        UTC
      </button>
      <button
        type="button"
        aria-pressed={ useLocalZone }
        onClick={ () => setUseLocalZone( true ) }
        className={ clsx( styles.timezoneOption, { [styles.active]: useLocalZone } ) }
      >
        Local
      </button>
    </div>
  );
}
